import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export interface ExperimentsEnabledResponseDTO {
    experiment: string[];
    control: string[];
}

interface CheckedExperiment {
    name: string;
    group: string;
}

export interface ExperimentsState {
    enabled: Record<string, string>;
    checked: CheckedExperiment[];
}

export const INITIAL_STATE: ExperimentsState = {
    enabled: {},
    checked: [],
};

export const ENABLED_EXPERIMENT = 'ENABLED_EXPERIMENT';
export const CHECK_EXPERIMENT = 'CHECK_EXPERIMENT';

interface PayloadTypes {
    [ENABLED_EXPERIMENT]: Record<string, string>;
    [CHECK_EXPERIMENT]: CheckedExperiment;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setEnabledExp = actionCreator(ENABLED_EXPERIMENT);
export const addCheckedExp = actionCreator(CHECK_EXPERIMENT);

export default createReducer<ExperimentsState, PayloadTypes>(INITIAL_STATE, {
    [ENABLED_EXPERIMENT]: (state, { payload }) => {
        return {
            ...state,
            enabled: payload,
        };
    },
    [CHECK_EXPERIMENT]: (state, { payload }) => {
        return {
            ...state,
            checked: [...state.checked, { name: payload.name, group: payload.group }],
        };
    },
});
